import { apiClient } from 'lib/api';
import { isAxiosError } from 'axios';
import type { NotificationChannel } from '../types';
import { queryOptions } from '@tanstack/react-query';
import type { QueryFunctionContext } from '@tanstack/react-query';

interface NotificationChannelsResponse {
  data: NotificationChannel[];
}

const getNotificationChannels = async ({ signal }: QueryFunctionContext<[string]>): Promise<NotificationChannel[]> => {
  const res = await apiClient.get<NotificationChannelsResponse>(`/notification_channels`, {
    signal,
  });
  if (isAxiosError(res)) {
    const error = new Error('Notification level');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }
  return res.data.data;
};

export const notificationChannelOptions = queryOptions({
  queryFn: getNotificationChannels,
  queryKey: ['notification_channels'],
  staleTime: 60 * 30 * 1000,
});
